<template>
  <v-container fluid class="pa-6">
    <!-- KPI Cards Section -->
    <v-row class="mb-4 mb-md-6">
      <v-col cols="6" sm="6" lg="3">
        <v-card class="kpi-card elevation-0" outlined>
          <v-card-text class="pa-3 pa-sm-5">
            <div class="kpi-icon d-none d-sm-flex">
              <v-icon color="primary">mdi-swap-vertical</v-icon>
            </div>
            <div class="kpi-content">
              <div class="kpi-label">Total Movimientos</div>
              <div class="kpi-value">{{ totalMovements }}</div>
              <div class="kpi-subtitle d-none d-sm-flex">
                <v-icon x-small color="success">mdi-calendar</v-icon>
                Últimos 30 días
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" sm="6" lg="3">
        <v-card class="kpi-card elevation-0" outlined>
          <v-card-text class="pa-3 pa-sm-5">
            <div class="kpi-icon d-none d-sm-flex">
              <v-icon color="success">mdi-package-variant</v-icon>
            </div>
            <div class="kpi-content">
              <div class="kpi-label">Unidades</div>
              <div class="kpi-value">{{ formatNumber(totalQuantity) }}</div>
              <div class="kpi-subtitle d-none d-sm-flex">
                <v-icon x-small color="info">mdi-archive</v-icon>
                En movimiento
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" sm="6" lg="3">
        <v-card class="kpi-card elevation-0" outlined>
          <v-card-text class="pa-3 pa-sm-5">
            <div class="kpi-icon d-none d-sm-flex">
              <v-icon color="warning">mdi-cash</v-icon>
            </div>
            <div class="kpi-content">
              <div class="kpi-label">Valor Costo</div>
              <div class="kpi-value">{{ formatCurrency(totalCost) }}</div>
              <div class="kpi-subtitle d-none d-sm-flex">Total en costos</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" sm="6" lg="3">
        <v-card class="kpi-card elevation-0" outlined>
          <v-card-text class="pa-3 pa-sm-5">
            <div class="kpi-icon d-none d-sm-flex">
              <v-icon color="info">mdi-cash-multiple</v-icon>
            </div>
            <div class="kpi-content">
              <div class="kpi-label">Valor Precio</div>
              <div class="kpi-value">{{ formatCurrency(totalPrice) }}</div>
              <div class="kpi-subtitle d-none d-sm-flex">Total en precios</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Main Content Card -->
    <v-card class="main-card elevation-0" outlined>
      <!-- Header with Actions -->
      <v-card-title class="pa-0">
        <v-toolbar flat class="minimal-toolbar">
          <h2 class="section-title" :class="{ 'text-h6': $vuetify.breakpoint.mobile }">
            Movimientos de Inventario
          </h2>
          <v-spacer></v-spacer>

          <!-- Action Menu -->
          <v-menu offset-y transition="slide-y-transition">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" fab small v-bind="attrs" v-on="on">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item to="/IAIn">
                <v-list-item-icon>
                  <v-icon>mdi-package-variant-plus</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Ajustes de Entrada</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/IAOut">
                <v-list-item-icon>
                  <v-icon>mdi-package-variant-minus</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Ajustes de Salida</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item to="/WarrantyIn">
                <v-list-item-icon>
                  <v-icon>mdi-shield-plus</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Entrada a Garantía</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/WarrantyOut">
                <v-list-item-icon>
                  <v-icon>mdi-shield-remove</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Salida de Garantía</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item to="/Warehouse">
                <v-list-item-icon>
                  <v-icon>mdi-truck-fast</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Traslado de Bodega</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/Promotion">
                <v-list-item-icon>
                  <v-icon>mdi-sale</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Traslado a Promoción</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-card-title>

      <!-- Filters Section -->
      <v-card-text class="py-4">
        <v-row>
          <v-col cols="12" md="3">
            <v-select
              v-model="even_code"
              :items="events_list"
              item-value="code"
              item-text="name"
              label="Tipo de Movimiento"
              clearable
              outlined
              dense
              prepend-inner-icon="mdi-filter"
              @change="filter_data"
              hide-details="auto"
            />
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="dateFrom"
              label="Fecha Desde"
              type="date"
              outlined
              dense
              prepend-inner-icon="mdi-calendar"
              hide-details="auto"
            />
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="dateTo"
              label="Fecha Hasta"
              type="date"
              outlined
              dense
              prepend-inner-icon="mdi-calendar"
              hide-details="auto"
            />
          </v-col>
          <v-col cols="12" md="3" class="d-flex align-center">
            <v-btn color="primary" @click="get_report" :loading="loading_status" block>
              <v-icon left>mdi-magnify</v-icon>
              Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Desktop Table / Mobile List -->
      <template v-if="$vuetify.breakpoint.mdAndUp">
        <!-- Desktop Table View -->
        <v-data-table
          :headers="headers"
          :items="filteredData"
          :items-per-page="10"
          item-key="id"
          sort-by="order_date"
          sort-desc
          :loading="loading_status"
          loader-height="3"
          loading-text="Cargando movimientos..."
          @click:row="get_e_doc"
          class="minimal-table clickable-rows"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, 100],
          }"
        >
          <!-- Document with Type -->
          <template v-slot:[`item.document`]="{ item }">
            <div class="document-info">
              <div class="document-number">
                <v-icon small class="mr-2" :color="getEventColor(item.order_number)">
                  {{ getEventIcon(item.order_number) }}
                </v-icon>
                {{ item.order_number }}
              </div>
              <div class="document-type text-caption grey--text">
                {{ getEventName(item.order_number) }}
              </div>
            </div>
          </template>

          <!-- Product Info -->
          <template v-slot:[`item.product`]="{ item }">
            <div class="product-info">
              <div class="product-main">Ref: {{ item.refe }} - {{ item.colorName }}</div>
              <div class="product-details text-caption grey--text">
                {{ item.brand }} | {{ item.category }}
              </div>
            </div>
          </template>

          <!-- Size & Quantity -->
          <template v-slot:[`item.size_qty`]="{ item }">
            <div class="size-qty-info">
              <v-chip small label class="mr-2">{{ item.talla }}</v-chip>
              <span class="font-weight-medium">{{ item.quantity }} und</span>
            </div>
          </template>

          <!-- Values -->
          <template v-slot:[`item.values`]="{ item }">
            <div class="values-info text-right">
              <div class="value-price font-weight-medium">
                {{ formatCurrency(item.tprice) }}
              </div>
              <div class="value-cost text-caption grey--text">
                Costo: {{ formatCurrency(item.tcost) }}
              </div>
            </div>
          </template>

          <!-- Footer with totals -->
          <template v-slot:body.append>
            <tr class="grey lighten-4">
              <td colspan="2" class="text-right font-weight-bold">TOTALES</td>
              <td class="text-center font-weight-bold">
                {{ formatNumber(totalQuantity) }} und
              </td>
              <td class="text-right font-weight-bold">
                <div>{{ formatCurrency(totalPrice) }}</div>
                <div class="text-caption">Costo: {{ formatCurrency(totalCost) }}</div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>

      <template v-else>
        <!-- Mobile List View -->
        <v-list v-if="filteredData.length > 0" class="py-0">
          <template>
            <v-list-item
              v-for="item in filteredData"
              :key="item.id"
              @click="get_e_doc(item)"
              class="px-4 py-3"
            >
              <v-list-item-content>
                <div class="d-flex justify-space-between align-start mb-2">
                  <div>
                    <div class="font-weight-medium d-flex align-center">
                      <v-icon
                        small
                        class="mr-1"
                        :color="getEventColor(item.order_number)"
                      >
                        {{ getEventIcon(item.order_number) }}
                      </v-icon>
                      {{ item.order_number }}
                    </div>
                    <div class="text-caption grey--text">
                      {{ getEventName(item.order_number) }} • {{ item.order_date }}
                    </div>
                  </div>
                  <v-chip small label>{{ item.talla }}</v-chip>
                </div>

                <div class="mb-2">
                  <div class="text-body-2">{{ item.refe }} - {{ item.color }}</div>
                  <div class="text-caption grey--text">
                    {{ item.marca }} | {{ item.categoria }}
                  </div>
                </div>

                <v-row no-gutters>
                  <v-col cols="4">
                    <div class="text-caption grey--text">Cantidad</div>
                    <div class="font-weight-medium">{{ item.quantity }}</div>
                  </v-col>
                  <v-col cols="4">
                    <div class="text-caption grey--text">Costo</div>
                    <div class="font-weight-medium">{{ formatCurrency(item.tcost) }}</div>
                  </v-col>
                  <v-col cols="4" class="text-right">
                    <div class="text-caption grey--text">Precio</div>
                    <div class="font-weight-medium">
                      {{ formatCurrency(item.tprice) }}
                    </div>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider v-if="index < filteredData.length - 1" :key="`div-${item.id}`" />
          </template>

          <!-- Mobile Totals -->
          <v-list-item class="grey lighten-4 py-3">
            <v-list-item-content>
              <div class="font-weight-bold text-center mb-2">TOTALES</div>
              <v-row no-gutters>
                <v-col cols="4">
                  <div class="text-caption">Cantidad</div>
                  <div class="font-weight-bold">{{ formatNumber(totalQuantity) }}</div>
                </v-col>
                <v-col cols="4">
                  <div class="text-caption">Costo</div>
                  <div class="font-weight-bold">{{ formatCurrency(totalCost) }}</div>
                </v-col>
                <v-col cols="4" class="text-right">
                  <div class="text-caption">Precio</div>
                  <div class="font-weight-bold">{{ formatCurrency(totalPrice) }}</div>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <!-- Empty State -->
        <div v-else-if="!loading_status" class="text-center py-12">
          <v-icon size="64" color="grey lighten-2">mdi-package-variant-closed</v-icon>
          <h3 class="text-h6 mt-4 grey--text">No hay movimientos en este período</h3>
          <p class="grey--text mt-2">Intenta ajustar los filtros de búsqueda</p>
        </div>
      </template>
    </v-card>

    <!-- Document Viewer Dialog -->
    <noteViewer :item="item" :dialog="dialog" @close="dialog = false" />

    <!-- Snackbar para mensajes -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false"> Cerrar </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import {
  webserver,
  getToday,
  getdays_ago,
  formatCurrency,
} from "@/services/webserver.js";
import noteViewer from "@/components/doc_viewer_report.vue";

export default {
  name: "GetEvents",
  components: { noteViewer },
  data() {
    return {
      // Snackbar
      snackbar: {
        show: false,
        text: "",
        color: "info",
        timeout: 3000,
      },

      // Filters
      even_code: "",
      dateFrom: getdays_ago(-30),
      dateTo: getToday(),

      // UI State
      loading_status: false,
      dialog: false,
      valid: false,

      // Data
      items: [],
      filteredData: [],
      item: { doc: null, items: [], payments: [] },

      // Headers modernizados
      headers: [
        {
          text: "Documento",
          value: "document",
          sortable: false,
          width: "25%",
        },
        {
          text: "Producto",
          value: "product",
          sortable: false,
          width: "35%",
        },
        {
          text: "Talla / Cantidad",
          value: "size_qty",
          align: "center",
          width: "20%",
        },
        {
          text: "Valores",
          value: "values",
          align: "right",
          width: "20%",
        },
      ],

      // Event types
      events_list: [
        { code: "OP", name: "Orden de Pedido" },
        { code: "OC", name: "Orden de Compra" },
        { code: "AJ", name: "Ajuste" },
        { code: "CP", name: "Cambio de Precio" },
        { code: "EI", name: "Entrada Inventario" },
        { code: "SI", name: "Salida Inventario" },
        { code: "GI", name: "Ingreso Garantía" },
        { code: "GS", name: "Salida Garantía" },
        { code: "PS", name: "Salida de Promoción" },
        { code: "PE", name: "Entrada de Promoción" },
        { code: "DV", name: "Devolución" },
        { code: "CD", name: "Cambio de Documento" },
        { code: "TB", name: "Traslado Bodega" },
      ],

      // Validation rules
      f_required: [(v) => !!v || "Campo requerido"],
    };
  },

  computed: {
    totalMovements() {
      return this.filteredData.length;
    },

    totalQuantity() {
      return this.filteredData.reduce((sum, item) => sum + (item.quantity || 0), 0);
    },

    totalCost() {
      return this.filteredData.reduce((sum, item) => sum + (item.tcost || 0), 0);
    },

    totalPrice() {
      return this.filteredData.reduce((sum, item) => sum + (item.tprice || 0), 0);
    },
  },

  mounted() {
    this.get_report();
  },

  methods: {
    // Mostrar mensajes
    showMessage(text, color = "info", timeout = 3000) {
      this.snackbar = {
        show: true,
        text,
        color,
        timeout,
      };
    },

    // Formatear moneda
    formatCurrency,

    // Formatear números
    formatNumber(value) {
      if (!value && value !== 0) return "0";
      return parseFloat(value).toLocaleString("es", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },

    // Obtener nombre del evento
    getEventName(orderNumber) {
      const prefix = orderNumber.substring(0, 2);
      const event = this.events_list.find((e) => e.code === prefix);
      return event ? event.name : prefix;
    },

    // Obtener icono del evento
    getEventIcon(orderNumber) {
      const prefix = orderNumber.substring(0, 2);
      const icons = {
        OP: "mdi-file-document",
        OC: "mdi-cart",
        AJ: "mdi-adjust",
        CP: "mdi-tag",
        EI: "mdi-package-variant-plus",
        SI: "mdi-package-variant-minus",
        GI: "mdi-shield-plus",
        GS: "mdi-shield-remove",
        PS: "mdi-sale",
        PE: "mdi-percent",
        DV: "mdi-undo",
        CD: "mdi-file-swap",
        TB: "mdi-truck",
      };
      return icons[prefix] || "mdi-file";
    },

    // Obtener color del evento
    getEventColor(orderNumber) {
      const prefix = orderNumber.substring(0, 2);
      const colors = {
        OP: "primary",
        OC: "success",
        AJ: "warning",
        CP: "info",
        EI: "green",
        SI: "red",
        GI: "orange",
        GS: "deep-orange",
        PS: "purple",
        PE: "indigo",
        DV: "error",
        CD: "blue-grey",
        TB: "teal",
      };
      return colors[prefix] || "grey";
    },

    // Filtrar datos
    filter_data() {
      if (!this.even_code) {
        this.filteredData = this.items;
        return;
      }

      this.filteredData = this.items.filter((item) => {
        return item.order_number.startsWith(this.even_code);
      });

      this.showMessage(
        `Mostrando ${this.filteredData.length} movimientos de tipo ${this.getEventName(
          this.even_code + "XX"
        )}`,
        "info"
      );
    },

    // Sumar tabla
    sumTable(table, key) {
      return parseFloat(
        this[table].reduce((a, b) => a + (parseFloat(b[key]) || 0), 0)
      ).toLocaleString(2);
    },

    // Obtener reporte
    get_report() {
      this.loading_status = true;

      const qry = {
        store: window.store?.store_id || window.profile?.store_id,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        events:
          "'OP','OC','AJ','CP','stockIn','stockOut','G-IN','G-OUT','PS','PE','DV','CD','TB'",
      };

      webserver(
        "get_events",
        qry,
        (data) => {
          this.loading_status = false;

          // Procesar datos
          this.items = data.map((item) => ({
            ...item,
            quantity: parseFloat(item.quantity || 0),
            tcost: parseFloat(item.quantity || 0) * parseFloat(item.costo || 0),
            tprice: parseFloat(item.quantity || 0) * parseFloat(item.price || 0),
          }));

          this.filteredData = this.items;
          this.showMessage(`${this.items.length} movimientos cargados`, "success");
        },
        (error) => {
          this.loading_status = false;
          this.showMessage("Error al cargar movimientos: " + error, "error");
        }
      );
    },

    // Obtener documento
    get_e_doc(item) {
      const doc = {
        store: item.store,
        issueDate: item.order_date,
        did: item.order_number,
      };

      this.loading_status = true;

      webserver(
        "get_invoice_fe",
        doc,
        (data) => {
          this.loading_status = false;
          this.item = data;
          this.dialog = true;
        },
        (error) => {
          this.loading_status = false;
          this.showMessage("Error al cargar el documento: " + error, "error");
        }
      );
    },
  },
};
</script>

<style scoped>
/* KPI Cards */
.kpi-card {
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.kpi-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.kpi-card .v-card__text {
  display: flex;
  align-items: center;
  gap: 16px;
}

.kpi-icon {
  background-color: #f5f5f5;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.kpi-icon .v-icon {
  font-size: 28px !important;
}

.kpi-content {
  flex: 1;
  min-width: 0;
}

.kpi-label {
  font-size: 0.875rem;
  color: #666;
  font-weight: 500;
  margin-bottom: 4px;
}

.kpi-value {
  font-size: 1.75rem;
  font-weight: 700;
  color: #333;
  line-height: 1.2;
}

.kpi-subtitle {
  font-size: 0.75rem;
  color: #999;
  margin-top: 4px;
  display: flex;
  align-items: center;
}

/* Main Card */
.main-card {
  border: 1px solid #e0e0e0;
}

.minimal-toolbar {
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 24px;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
}

/* Data Table */
.minimal-table {
  border: none !important;
}

.minimal-table >>> .v-data-table__wrapper {
  border: none;
}

.minimal-table >>> thead tr th {
  background-color: #fafafa !important;
  font-weight: 600 !important;
  color: #666 !important;
  border-bottom: 2px solid #e0e0e0 !important;
  font-size: 0.875rem !important;
  padding: 16px !important;
}

.minimal-table >>> tbody tr {
  border-bottom: 1px solid #f0f0f0 !important;
  transition: background-color 0.2s;
}

.minimal-table >>> tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.minimal-table >>> tbody tr td {
  padding: 16px !important;
  font-size: 0.875rem !important;
}

/* Clickable rows */
.clickable-rows >>> tbody tr {
  cursor: pointer;
}

/* Custom cells */
.document-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.document-number {
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
}

.product-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.size-qty-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.values-info {
  min-width: 120px;
}

/* Loading */
.minimal-table >>> .v-data-table__progress {
  height: 2px !important;
}

/* Responsive */
@media (max-width: 600px) {
  .kpi-value {
    font-size: 1.25rem;
  }

  .section-title {
    font-size: 1.125rem;
  }

  .kpi-card .v-card__text {
    flex-direction: column;
    text-align: center;
    padding: 16px !important;
  }

  .kpi-icon {
    margin-bottom: 8px;
  }

  .minimal-toolbar {
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px !important;
  }
}

@media (max-width: 960px) {
  .kpi-value {
    font-size: 1.5rem;
  }

  .section-title {
    font-size: 1.25rem;
  }

  .kpi-card .v-card__text {
    flex-direction: row;
    text-align: left;
  }
}
</style>
